<template>
    <div id="page" class="page">

        <interne_menu></interne_menu>
               
        <!-- apaym free -->
       


        <section id="download-4" class="bg-fixed sct_bck p-top-100 download-section division grey_bck_section">
            <div class="container">
                <div class="row">

                                
                    <!-- DOWNLOAD TEXT -->
                    <div class="col-lg-10 offset-lg-1">	
                        <div class="download-txt">
                            
                            <!-- Title -->
                            <h2 class="h2-xs">Téléchargez APAYM</h2>

                            <!-- Text -->
                            <p class="p-lg">APAYM : Paie, Transfert et Recharge avec toutes les cartes Visa</p>

                            <!-- HERO STORE BADGES -->													
                            <div class="stores-badge">

                                 <!-- Google Play -->
                                 <a href="https://play.google.com/store/apps/details?id=weblogy.com.carteabidjan" class="store">
                                    <img class="appstore-original badge_sect" src="@/assets/images/play_store_badge.webp" width="150" alt="appstore-logo">
                                </a> 

                               <!-- AppStore -->
                                <a href="https://apps.apple.com/app/id1211381693" class="store">
                                    <img class="googleplay-original badge_sect" src="@/assets/images/app-store-bage.webp" width="150" alt="googleplay-logo">
                                </a>                                                                            
                                
                                <!-- App Gallery -->
                                <a href="https://appgallery.huawei.com/app/C104470711" class="store">
                                    <img class="googleplay-original badge_sect" src="@/assets/images/app-gallery-badge.webp" width="150" alt="googleplay-logo">
                                </a>
                                                       
                                

                            </div>

                            


                        </div>
                    </div>

                    <div class="col-lg-12 ">

                        <img class="googleplay-original  pic_bd" src="@/assets/images/ecran-Play-store1.jpg"  alt="image APAYM">  
                    </div>

                        

                    <div class="col-lg-10 offset-lg-2">

                        <p class="dows f-bold">La Super App APAYM vous permets de gérer vos finances en temps réel, de faire:</p>

                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p class="dows"> Faire des transferts vers toutes les cartes Visa, compte bancaires et Mobile Money quelque soit votre banque</p>							
                            </div>
                                            
                            <!-- Text -->	
                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p class="dows">Payer et retirer de l’argent partout dans le monde</p>							
                            </div>

                            <!-- Text -->	
                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p class="dows">Carte virtuelle offerte avec un plafond de 2 millions pour vos paiements en ligne partout dans le monde</p>							
                            </div>
                            

                            <p class="dows spdws f-bold">La super app APAYM c’est aussi :</p>

                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p class="dows"> Faire des transferts vers toutes les cartes Visa, compte bancaires et Mobile Money quelque soit votre banque</p>							
                            </div>
                                            
                        
                            <!-- Text -->	
                            <div class="box-list m-top-15 animated fadeInLeft visible less" data-animation="fadeInLeft" data-animation-delay="600">					
                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                    <p class="dows">APAYM Pro : la solution de paiement à compensation immédiate pour les marchands</p>							
                            </div>
                           

                    </div>
                    
                    
                    <!-- END DOWNLOAD TEXT -->


                    <!-- DOWNLOAD IMAGE 
                    <div class="col-md-12">	
                        <div class="download-img text-center">
                            <img class="img-fluid disp_img" src="@/assets/images/phones_app.webp" alt="download-image">
                        </div>
                    </div>-->
                    
                </div>	  <!-- End row -->
            </div>	   <!-- End container -->		
        </section>

        <footer_menu></footer_menu>
    </div>

</template>

<script>
import interne_menu  from '../components/interne_menu.vue';
import footer_menu  from '../components/footer_menu.vue';
export default{
    name :'apaym_pro',
    components:{
      'interne_menu' :interne_menu,
      'footer_menu' :footer_menu
    } ,

    mounted() {
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('android')) {
      if (userAgent.includes('huawei') || userAgent.includes('honor')) {
        window.location.href = 'https://appgallery.huawei.com/app/C104470711';
      } else {
        window.location.href = 'https://play.google.com/store/apps/details?id=weblogy.com.carteabidjan';
      }
    } else if (userAgent.includes('iphone') || userAgent.includes('ipad') || userAgent.includes('ipod')) {
      window.location.href = 'https://apps.apple.com/app/id1211381693';
    } 
  }
}

</script>

<style scoped>
.less{
    margin-bottom: 100px;
}
.pic_bd{
    width: 100%;
    max-width: 1110px;
    margin-bottom: 40px;
    border: 1px solid #efefef;
}
.p-top-100 {
    padding-top: 147px !important;
}
.spdws{
    margin-top: 30px;
}
.dows{
    padding: 0 0 !important;    
}
.f-bold{
    font-weight: 500;
}
.sct_bck{
    background: url(@/assets/images/95b26da8.png) no-repeat;   
}

.orange{
color: #ff9e00;
}


@media screen and (max-width: 767px) {
    .p-top-100 {
    padding-top: 90px !important;
}
   
    .badge_sect {
    max-width: 108px !important;
}
 
}
</style>

